/*
 * XYNE Redesign — Privacy choices page
 * Wires the three toggle controls to Shopify's window.Shopify.customerPrivacy
 * API. Shopify auto-loads this on every storefront page; saving here writes to
 * the official _tracking_consent cookie which propagates to GA4, Meta, TikTok,
 * etc., via Shopify's Customer Privacy framework. No third-party CMP needed.
 *
 * API docs: https://shopify.dev/docs/api/customer-privacy
 */
(function () {
  'use strict';

  var panel = document.querySelector('[data-rd-consent-panel]');
  if (!panel) return;

  var analyticsToggle = panel.querySelector('[data-rd-consent="analytics"]');
  var marketingToggle = panel.querySelector('[data-rd-consent="marketing"]');
  var saveBtn = panel.querySelector('[data-rd-consent-save]');
  var denyAllBtn = panel.querySelector('[data-rd-consent-deny-all]');
  var statusEl = panel.querySelector('[data-rd-consent-status]');

  function getApi() {
    return (window.Shopify && window.Shopify.customerPrivacy) || null;
  }

  /**
   * Reflect current consent state in the toggle UI.
   * Falls back gracefully if the API hasn't loaded yet.
   */
  function syncFromCookie() {
    var api = getApi();
    if (!api) return;

    var allowAnalytics = false;
    var allowMarketing = false;

    try {
      // Newer API: getTrackingConsent() returns { analytics, marketing, ... }
      if (typeof api.getTrackingConsent === 'function') {
        var consent = api.getTrackingConsent() || {};
        allowAnalytics = consent.analytics === true;
        allowMarketing = consent.marketing === true;
      } else if (typeof api.analyticsProcessingAllowed === 'function') {
        allowAnalytics = !!api.analyticsProcessingAllowed();
        allowMarketing =
          (typeof api.marketingAllowed === 'function' && !!api.marketingAllowed()) ||
          (typeof api.thirdPartyMarketingAllowed === 'function' && !!api.thirdPartyMarketingAllowed());
      }
    } catch (e) {
      // API quirk between Shopify versions — leave defaults off.
    }

    setToggle(analyticsToggle, allowAnalytics);
    setToggle(marketingToggle, allowMarketing);
  }

  function setToggle(input, on) {
    if (!input) return;
    input.checked = !!on;
    var label = input.closest('.rd-privacy__toggle');
    if (!label) return;
    var onText = label.querySelector('[data-rd-toggle-on]');
    var offText = label.querySelector('[data-rd-toggle-off]');
    if (onText) onText.hidden = !on;
    if (offText) offText.hidden = !!on;
  }

  function showStatus(msg, kind) {
    if (!statusEl) return;
    statusEl.textContent = msg;
    statusEl.dataset.kind = kind || 'ok';
  }

  /**
   * Push consent to Shopify. Tries the modern setTrackingConsent first,
   * falls back to the older customerPrivacy.setTrackingConsent shape.
   */
  function persistConsent(analytics, marketing) {
    var api = getApi();
    if (!api) {
      showStatus(
        "Couldn't reach the privacy API. Use the request form below and we'll opt you out manually.",
        'error'
      );
      return false;
    }

    var payload = {
      analytics: !!analytics,
      marketing: !!marketing,
      preferences: !!marketing,
      sale_of_data: !!marketing
    };

    try {
      if (typeof api.setTrackingConsent === 'function') {
        api.setTrackingConsent(payload, function (err) {
          if (err) {
            showStatus("Saved locally, but couldn't reach Shopify. We'll re-sync on the next page load.", 'warn');
          } else {
            showStatus('Saved. Your choices apply across xyne.health on this device.', 'ok');
          }
        });
        return true;
      }

      if (typeof api.userCanBeTracked === 'function') {
        // Older shape — best-effort.
        if (analytics === false || marketing === false) {
          if (typeof api.optOut === 'function') api.optOut();
        } else {
          if (typeof api.setMetafield === 'function') {
            api.setMetafield('marketing_allowed', marketing);
          }
        }
        showStatus('Saved.', 'ok');
        return true;
      }
    } catch (e) {
      showStatus('Saved locally — Shopify rejected the call. Use the form below if it sticks.', 'warn');
      return false;
    }

    showStatus('Saved.', 'ok');
    return true;
  }

  function readToggleState(input) {
    return !!(input && input.checked);
  }

  function attach() {
    [analyticsToggle, marketingToggle].forEach(function (input) {
      if (!input) return;
      input.addEventListener('change', function () {
        setToggle(input, input.checked);
      });
    });

    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        var ok = persistConsent(
          readToggleState(analyticsToggle),
          readToggleState(marketingToggle)
        );
        if (ok) {
          saveBtn.classList.add('rd-privacy__btn--saved');
          setTimeout(function () {
            saveBtn.classList.remove('rd-privacy__btn--saved');
          }, 1800);
        }
      });
    }

    if (denyAllBtn) {
      denyAllBtn.addEventListener('click', function () {
        setToggle(analyticsToggle, false);
        setToggle(marketingToggle, false);
        persistConsent(false, false);
      });
    }
  }

  // Shopify's Customer Privacy lib loads asynchronously. Wait for it,
  // but cap the wait so the UI is interactive even if the API never lands.
  function waitForApi(maxMs) {
    var started = Date.now();
    function tick() {
      if (getApi()) {
        syncFromCookie();
        return;
      }
      if (Date.now() - started > maxMs) {
        showStatus('', 'ok');
        return;
      }
      setTimeout(tick, 200);
    }
    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      attach();
      waitForApi(4000);
    });
  } else {
    attach();
    waitForApi(4000);
  }
})();
